<template>
  <div>
    <el-radio-group v-model="radio" @change="agreeChange">

    <el-radio label="0">{{$t('msg.Player_Records')}}</el-radio>
    <el-radio label="1" v-if="level !== 2">{{$t('msg.Agent_Records')}}</el-radio>
    </el-radio-group>

    <el-form :model="formData" :rules="radio == 0 ? userRules : porxyRules" ref="user">
      <el-form-item :label="$t('msg.User_Name2')" prop="sid">
        <el-input v-model="formData.sid" autocomplete="off"
          @input="radio == '0' ? formData.sid = formData.sid.replace(/[^0-9]/g, '') : null"></el-input>
      </el-form-item>
      <el-button type="primary" @click="getInfo">{{$t('msg.OK2')}}</el-button>

    </el-form>
    <el-divider></el-divider>
    <div v-if="showTable == 0">
      <el-table :data="tableData" tooltip-effect="dark" size="mini">
        <el-table-column prop="user_id" :label="$t('msg.User_Name2')" width="120px">
        </el-table-column>
        <el-table-column prop="lastlogin" :label="$t('msg.DisOnlineDay')" width="120px">
        </el-table-column>
        <el-table-column prop="proxy_username" :label="$t('msg.agent')">
          <template slot-scope="scope">
            <span v-if="scope.row.proxy_level == 2">{{ scope.row.proxy_username }}</span>
            <el-link v-else type="primary" @click="chiAccountList(scope.row.proxy_username)">{{ scope.row.proxy_username }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="coins" :label="$t('msg.Score')">
        </el-table-column>
        <el-table-column prop="coins_win" :label="$t('msg.Available_withdraw')">
        </el-table-column>
        <el-table-column prop="realname" :label="$t('msg.Name2')">
        </el-table-column>
        <el-table-column prop="pnum" :label="$t('msg.Tel')" width="150px">
        </el-table-column>
        <el-table-column prop="description" :label="$t('msg.Description1')" width="120px" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column :label="$t('msg.Operation')"  :width="getUserColWidth()">
          <template slot-scope="scope">
            <el-button type="warning" size="mini" @click="setScore(scope.row.user_id, 0)">{{$t('msg.Set_score1')}}</el-button>
            <el-button type="warning" size="mini" @click="SetScoreLog(scope.row.user_id, 0)">{{$t('msg.score_log')}}</el-button>
            <el-button type="warning" size="mini" @click="editUser(scope.row.user_id)">{{$t('msg.edit')}}</el-button>
            <el-button type="warning" size="mini" @click="queryReport(scope.row.user_id, 0)">{{$t('msg.report')}}</el-button>
            <span>
            <el-button type="warning" size="mini" @click="banUser(scope.row.user_id)"
                       v-if="scope.row.state == 0">{{$t('msg.disable')}}
            </el-button>
            <el-button type="danger" size="mini" @click="permissionUser(scope.row.user_id)"
                       v-if="scope.row.state != 0">{{$t('msg.enable')}}
            </el-button>
              </span>

          </template>
        </el-table-column>

      </el-table>
    </div>
    <div v-if="showTable == 1">
      <el-table :data="tableData" tooltip-effect="dark" size="mini">
        <el-table-column prop="username" :label="$t('msg.User_Name2')" width="120px">
        </el-table-column>
        <el-table-column prop="price" :label="$t('msg.Score')">
        </el-table-column>
        <el-table-column prop="realname" :label="$t('msg.Name1')">
        </el-table-column>
        <el-table-column prop="pnum" :label="$t('msg.Tel')" width="150px">
        </el-table-column>
        <el-table-column prop="description" :label="$t('msg.Description1')" width="120px" :show-overflow-tooltip="true">
        </el-table-column>

        <el-table-column :label="$t('msg.Operation')" :width="getProxyColWidth()">
          <template slot-scope="scope">
            <el-button type="warning" size="mini" @click="editProxy(scope.row.username)">{{$t('msg.edit')}}</el-button>
            <span>
              <el-button type="warning" size="mini" @click="banProxy(scope.row.username)"
                         v-if="scope.row.state == 0">{{$t('msg.disable')}}</el-button>
              <el-button type="danger" size="mini" @click="permissionProxy(scope.row.username)"
                         v-if="scope.row.state != 0">{{$t('msg.enable')}}</el-button>
            </span>

          </template>
        </el-table-column>
      </el-table>
    </div>

  </div>
</template>

<script>
import {GetUserInfo, GetProxyInfo, PermissionUser, BanUser, BanProxy, PermissionProxy} from '../api';

export default {
  name: "UserSearch",
  data() {
    var _userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    return {
      level: _userInfo.level,
      radio: '0',
      formData: {
        sid: ''
      },
      porxyRules: {
        sid: [
          {required: true, message: this.$t('msg.Please_enter_your_account_number'), trigger: 'blur'},
          {min: 7, max: 16, message: this.$t('msg.The_length_is_716_characters'), trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              // const reg = /^[\u4E00-\u9FA5A-Za-z0-9]+$/ 带有下划线_
              const reg = /^[A-Za-z0-9]+$/
              if (!reg.test(value)) {
                callback(new Error(this.$t('msg.Username_format_hint')))
              } else {
                callback()
              }
            },
            trigger: "blur"
          }
        ],
      },
      userRules: {
        sid: [
          {required: true, message: this.$t('msg.Please_enter_your_account_number'), trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9]+$/
              if (!reg.test(value)) {
                callback(new Error(this.$t('msg.UserId_must_be_7_digits')))
              } else {
                callback()
              }
            },
            trigger: "blur"
          }
        ],
      },
      tableData: [],
      showTable: -1,
      showSid: '',
      cache: {
        '0': { tableData: [], showTable: -1, sid: '' },
        '1': { tableData: [], showTable: -1, sid: '' }
      }
    }
  },
  methods: {
    getInfo() {
      var val = true
      var from = 'user'
      this.$refs[from].validate(valid => {
        if (!valid) {
          // 表单验证失败，显示错误消息...
          val = false
        }
      })
      if (val) {
        this.sendGetInfo()
      }
    },
    sendGetInfo() {
      if (this.radio == 0) {
        GetUserInfo({"user_id": this.formData.sid}).then((data) => {
          if (data.data.errcode === 0 && data.data.params.status === 0) {
            // this.tableData = [data.data.params.user]
            var tableData = [data.data.params.user]
            for (var i = 0; i < tableData.length; i++) {
              if (tableData[i]["online"] == 1) {
                tableData[i]["lastlogin"] = this.$t('msg.online')
              }
              else if (tableData[i].lastlogin){
                var timestamp = tableData[i].lastlogin
                let date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
                let Y = date.getFullYear() + '-';
                let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
                let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
                let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                tableData[i]["lastlogin"] = Y + M + D + h + m + s;
              }else {
                tableData[i]["lastlogin"] = ''
              }
            }
            this.tableData = tableData
            this.showTable = 0
            this.cache['0'] = { tableData: tableData, showTable: 0, sid: this.formData.sid }
            if (!this.tableData) {
              this.$alert(this.$t('msg.No_Data'), '', {
                confirmButtonText: this.$t('msg.OK2'),
                center: true,
                customClass:'alert'//添加类名
              });
            }
          } else {
            msg = data.data.params.msg
            if (!data.data.params.msg) {
              var msg = this.$t('msg.Failed_to_obtain_data')
            }
            this.$message.error(msg);
          }
        })
      } else {
        GetProxyInfo({"search_username": this.formData.sid}).then((data) => {
          if (data.data.errcode === 0 && data.data.params.status === 0) {
            var tableData = [data.data.params.data]
            for (var i = 0; i < tableData.length; i++) {
              var timestamp = tableData[i].lastlogin
              let date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
              var day = 1000 * 60 * 60 * 24;
              var now = new Date().getTime();
              var diffValue = now - date;
              var dayC = diffValue / day;
              tableData[i]["lastlogin"] = parseInt(dayC) + "天前";
            }
            this.tableData = tableData
            this.showTable = 1
            this.cache['1'] = { tableData: tableData, showTable: 1, sid: this.formData.sid }
            if (!this.tableData) {
              this.$alert(this.$t('msg.No_Data'), '', {
                confirmButtonText: this.$t('msg.OK2'),
                center: true,
                customClass:'alert'//添加类名

              });
            }
          } else {
            msg = data.data.params.msg
            if (!data.data.params.msg) {
              var msg = this.$t('msg.Failed_to_obtain_data')
            }
            this.$message.error(msg);
          }
        })
      }
    },
    setScore(sid, set_type) {
      this.$router.push({name: 'setScore', query: {'sid': sid, 'set_type': set_type}})
    },
    SetScoreLog(sid, user_type) {
      this.$router.push({name: 'setScoreLog', query: {'sid': sid, 'user_type': user_type}})
    },
    chiAccountList(sid) {
      this.$router.push({name: 'userSearch', query: {'sid': sid, 'user_type': '1'}})
      window.location.reload()
      return
    },
    editUser(user_id) {
      this.$router.push({name: 'editUser', query: {'user_id': user_id}})
    },
    editProxy(username) {
      this.$router.push({name: 'editProxy', query: {'proxyName': username}})
    },
    queryReport(sid, user_type) {
      if (user_type==1){
        this.$router.push({name: 'allQueryReport', query: {'sid': sid, 'user_type': user_type}})
      }else{
        this.$router.push({name: 'queryReport', query: {'sid': sid, 'user_type': user_type}})
      }
    },
    permissionUser(user_id) {
      PermissionUser({"user_ids": user_id}).then((data) => {
        if (data.data.errcode === 0 && data.data.params.status === 0) {
          this.$message.success(this.$t('msg.Modification_successful'));
        } else {
          msg = data.data.params.msg
          if (!data.data.params.msg) {
            var msg = this.$t('msg.Modification_failed')
          }
          this.$message.error(msg);
        }
      })
    },
    banUser(user_id) {
      BanUser({"user_id": user_id}).then((data) => {
        if (data.data.errcode === 0 && data.data.params.status === 0) {
          this.$message.success(this.$t('msg.Modification_successful'));
        } else {
          msg = data.data.params.msg
          if (!data.data.params.msg) {
            var msg = this.$t('msg.Modification_failed')
          }
          this.$message.error(msg);
        }
      })
    },
    banProxy(username) {
      BanProxy({ "search_username": username }).then((data) => {
        if (data.data.errcode === 0 && data.data.params.status === 0) {
          this.$message.success(this.$t('msg.Modification_successful'));
          this.getPorxyUserList()
        } else {
          msg = data.data.params.msg
          if (!data.data.params.msg) {
            var msg = this.$t('msg.Modification_failed')
          }
          this.$message.error(msg);
        }
      })
    },
    permissionProxy(username) {
      PermissionProxy({ "search_username": username }).then((data) => {
        if (data.data.errcode === 0 && data.data.params.status === 0) {
          this.$message.success(this.$t('msg.Modification_successful'));
          this.getPorxyUserList()
        } else {
          msg = data.data.params.msg
          if (!data.data.params.msg) {
            var msg = this.$t('msg.Modification_failed')
          }
          this.$message({
            message: msg,
            type: 'error',
            offset: 80
          });
        }
      })
    },
    agreeChange(newVal){
      var prev = newVal === '0' ? '1' : '0'
      this.cache[prev].tableData = this.tableData
      this.cache[prev].showTable = this.showTable
      this.cache[prev].sid = this.formData.sid

      var restored = this.cache[newVal]
      this.tableData = restored.tableData
      this.showTable = restored.showTable
      this.formData = { sid: restored.sid }
    },
    getUserColWidth() {
      var w = 6 * 80 + 30
      if (!this.$store.state.tab.isCollapse) { w += 180 }
      return w + 'px'
    },
    getProxyColWidth() {
      var w = 4 * 80 + 10
      if (!this.$store.state.tab.isCollapse) { w += 180 }
      return w + 'px'
    },
  },
  mounted() {
    if (this.$route.query.user_type == 0) {
      this.radio = '0'
    } else if (this.$route.query.user_type == 1) {
      this.radio = '1'
    }
    if (this.$route.query.sid) {
      this.formData.sid = String(this.$route.query.sid)
      this.sendGetInfo()
    }

  },
}
</script>

<style lang="less">
.el-button + .el-button, .el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0;
}
/* 使用媒体查询来调整样式 */
@media screen and (max-width: 500px) {
  .alert{
    width: 240px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/UserSearch.vue